import { useState, useRef, useEffect } from "react"
import { ChevronDown } from "lucide-react"
import { countries } from './countryList'
export function CustomCountrySelect({ value, onChange, error, isDark = false, className }) {
  const [isOpen, setIsOpen] = useState(false)
  const [highlightedIndex, setHighlightedIndex] = useState(-1)
  const selectRef = useRef(null)
  const listRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])

  const handleSelect = (country) => {
    onChange(country)
    setIsOpen(false)
    setHighlightedIndex(-1)
  }

  const handleKeyDown = (e) => {
    if (!isOpen) {
      if (e.key === "Enter" || e.key === " " || e.key === "ArrowDown") {
        e.preventDefault()
        setIsOpen(true)
        setHighlightedIndex(0)
      }
      return
    }

    switch (e.key) {
      case "Escape":
        setIsOpen(false)
        setHighlightedIndex(-1)
        break
      case "ArrowDown":
        e.preventDefault()
        setHighlightedIndex((prev) => (prev < countries.length - 1 ? prev + 1 : 0))
        break
      case "ArrowUp":
        e.preventDefault()
        setHighlightedIndex((prev) => (prev > 0 ? prev - 1 : countries.length - 1))
        break
      case "Enter":
        e.preventDefault()
        if (highlightedIndex >= 0) {
          handleSelect(countries[highlightedIndex])
        }
        break
    }
  }

  return (
    <div className="relative" ref={selectRef}>
      <div
        className={`
          relative w-full h-11 px-3 py-2 bg-white border rounded cursor-pointer h-[36px]
          flex items-center justify-between
          transition-colors ${className}
        `}
        onClick={() => setIsOpen(!isOpen)}
        onKeyDown={handleKeyDown}
        tabIndex={0}
        role="combobox"
        aria-expanded={isOpen}
        aria-haspopup="listbox"
      >
        <span className={`text-sm ${value ? "text-gray-900" : "text-[rgba(77,77,77,0.40)]"}`}>{countries.find(item => item.code === value)?.label || "Select Country"}</span>
        <ChevronDown className={`w-4 h-4 text-gray-400 transition-transform ${isOpen ? "rotate-180" : ""}`} />
      </div>

      {isOpen && (
        <div className="absolute z-50 w-full mt-1 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-y-auto">
          <ul ref={listRef} role="listbox" className="py-1">
            {countries.map((country, index) => (
              <li
                key={country.code}
                className={`
                  flex items-center gap-3 px-3 py-2 cursor-pointer transition-colors
                  ${highlightedIndex === index ? "bg-[#F3F3F3]" : "hover:bg-[#F3F3F3]"}
                  ${value === country.label ? "bg-[#F3F3F3]" : ""}
                `}
                onClick={() => handleSelect(country.code)}
                onMouseEnter={() => setHighlightedIndex(index)}
                role="option"
                aria-selected={value === country.label}
              >
                { country.flag }
                <span className="text-gray-700 text-sm">{country.label}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}
